import { QuoteApplicationPrefill } from '@src/types/QuoteApplicationPrefill'
import { QueryFunctionContext, useQuery } from '@tanstack/react-query'
import { getApiClient } from '../api-client'

const SCOPE = 'quote'
const DETAIL = 'detail'

const keysFactory = {
  detail: (quoteId: string) => [{ scope: SCOPE, entity: DETAIL, quoteId }] as const,
}

const getQuote = async ({
  queryKey: [{ quoteId }],
}: QueryFunctionContext<ReturnType<(typeof keysFactory)['detail']>>) => {
  const apiClient = getApiClient()
  const response = await apiClient.get<QuoteApplicationPrefill>(`/quote/${encodeURIComponent(quoteId)}`)
  return response.data
}

export function useQuoteById(quoteId: string | null): [QuoteApplicationPrefill | null, boolean, boolean] {
  const { isFetching, isError, data } = useQuery({
    queryKey: keysFactory.detail(quoteId ?? ''),
    queryFn: getQuote,
    enabled: !!quoteId,
  })

  return [data ?? null, isFetching, isError]
}
